import cn from 'clsx';

import useIsMobile from '@/src/hooks/useIsMobile';
import ClinicPositionDesktopWidget from '@/src/profile/clinicTarget/components/ClinicPositionDesktopWidget';
import ClinicPositionMobileWidget from '@/src/profile/clinicTarget/components/ClinicPositionMobileWidget';
import TextLocal from '@/src/textLocal/containers/TextLocal';
import {Button, Carousel, Text} from '@/src/ui';

import css from '../styles/MultipleSearchVacancies.module.css';

const MAX_VACANCIES_DESKTOP_NUMBER = 3;

interface MultipleSearchVacanciesProps {
  data: Array<any>;
  onSeeAllClick: (...args: any) => any;
  onSuccessfulApplicationCallback: (...args: any) => any;
}

const MultipleSearchVacancies = ({
  data,
  onSeeAllClick,
  onSuccessfulApplicationCallback,
}: MultipleSearchVacanciesProps) => {
  const {isMaxWidth900: isMobile} = useIsMobile();

  return (
    <div className={css.widget}>
      <div className={css.heading}>
        <Text
          fontFamily={Text.FONT_FAMILY.RUBIK}
          fontSize={Text.FONT_SIZE.SIZE_32}
          fontWeight={Text.FONT_WEIGHT.MEDIUM}
        >
          <TextLocal id={'search.positions'} />
        </Text>
      </div>
      {isMobile ? (
        <div className={css.mobileContent}>
          <Carousel
            settings={{
              loop: false,
            }}
            navigationPosition={Carousel.NAVIGATION_POSITION.BOTTOM}
          >
            {data.map((vacancyItem) => {
              return (
                <div key={vacancyItem.id} className={css.mobilePositions}>
                  <ClinicPositionMobileWidget
                    {...vacancyItem}
                    withoutOffset
                    onSuccessfulApplicationCallback={
                      onSuccessfulApplicationCallback
                    }
                  />
                </div>
              );
            })}
          </Carousel>
        </div>
      ) : (
        <div className={css.desktopContent}>
          {data.map((positionItem, index) => {
            if (index >= MAX_VACANCIES_DESKTOP_NUMBER) {
              return null;
            }

            return (
              <div className={css.desktopItem} key={positionItem.id}>
                <ClinicPositionDesktopWidget
                  {...positionItem}
                  onSuccessfulApplicationCallback={
                    onSuccessfulApplicationCallback
                  }
                />
              </div>
            );
          })}
        </div>
      )}
      <div
        className={cn(css.buttonBlock, {
          [css.mobileButtonBlock]: isMobile,
        })}
      >
        <Button
          color={Button.COLOR.SECONDARY}
          onClick={onSeeAllClick}
          border={Button.BORDER.BOLD}
          height={Button.HEIGHT.SMALL}
        >
          <TextLocal id={'promoSection.see-all'} />
        </Button>
      </div>
    </div>
  );
};

export default MultipleSearchVacancies;
